module.exports = __webpack_public_path__ + "static/media/SHPE R2 Soccer Tournament Champions - LI.9b7933a2.jpeg";